import React from 'react';
import TalkToExpert from '../components/TalkToExpert';
import './ServicePage.css';

const AboutUs = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="service-title">About Sysmaco</h1>
            <p className="service-description">
              Your trusted technology partner committed to delivering innovative 
              IT solutions that drive business success and digital transformation.
            </p>
          </div>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <div className="content-grid">
            <div className="service-details">
              <h2>Our Story</h2>
              
              <div className="service-features">
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🏢</div>
                    <h3>Founded in 2010</h3>
                  </div>
                  <p>Started as a small IT consultancy with a vision to democratize technology for businesses of all sizes.</p>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">👥</div>
                    <h3>100+ Happy Clients</h3>
                  </div>
                  <p>Serving businesses across various industries with tailored IT solutions and exceptional service.</p>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🎆</div>
                    <h3>Award-Winning Service</h3>
                  </div>
                  <p>Recognized for excellence in customer service and innovative technology solutions.</p>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🚀</div>
                    <h3>Innovation Driven</h3>
                  </div>
                  <p>Constantly evolving with the latest technologies to provide cutting-edge solutions.</p>
                </div>
              </div>

              <div className="benefits-section">
                <h2>Our Mission & Values</h2>
                <ul className="benefits-list">
                  <li>✓ Customer-first approach in everything we do</li>
                  <li>✓ Commitment to excellence and quality</li>
                  <li>✓ Transparency in all business dealings</li>
                  <li>✓ Continuous learning and improvement</li>
                  <li>✓ Building long-term partnerships</li>
                  <li>✓ Environmental responsibility</li>
                </ul>
              </div>
            </div>

            <div className="service-sidebar">
              <div className="service-card">
                <h3>Company Stats</h3>
                <div className="highlight-item">
                  <span className="highlight-label">Founded:</span>
                  <span className="highlight-value">2010</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Team Size:</span>
                  <span className="highlight-value">10+ Experts</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Clients:</span>
                  <span className="highlight-value">100+</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Satisfaction:</span>
                  <span className="highlight-value">99.5%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TalkToExpert />
    </div>
  );
};

export default AboutUs;
